import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
// import Zoom from "react-medium-image-zoom";
// import UploadIcon from "@mui/icons-material/Upload";
// import layoutIm from "../../../assets/Images/spot1.png";
// import CreateIcon from "@mui/icons-material/Create";
import Tooltip from "@mui/material/Tooltip";
// import DeleteIcon from "@mui/icons-material/Delete";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// For Modal
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import CloseIcon from "@mui/icons-material/Close";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
// import AddIcon from "@mui/icons-material/Add";
import AvatarImg from "../../../assets/Images/avtarPic.png";
import moment from "moment";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

import {
 
  makeGetRequest,
  makePostRequest,
} from "../../../utils/utils";
import swal from "sweetalert";

// End
// import { Formik, Form } from "formik";
// import * as Yup from "yup";

function ApartmentHistory() {
  const navigate = useNavigate();

  // const [pdfImage, setPdfImage] = React.useState(
  //   require("../../../assets/Images/pdf.png")
  // );
  // const [txtImage, setTxtImage] = React.useState(
  //   require("../../../assets/Images/text.png")
  // );
  // const [excelImage, setExcelImage] = React.useState(
  //   require("../../../assets/Images/exel.png")
  // );
  // const [wordImage, setWordImage] = React.useState(
  //   require("../../../assets/Images/doc.png")
  // );

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  // For Modal
  const [open2] = React.useState(false);
  // const [, setScroll2] = React.useState("paper");

  // const handleClickOpen2 = (scrollType) => () => {
  //   setOpen2(true);
  //   setScroll2(scrollType);
  // };

  // const handleClose2 = () => {
  //   setOpen2(false);
  // };

  // const descriptionElementRef2 = React.useRef(null);
  // React.useEffect(() => {
  //   if (open2) {
  //     const { current: descriptionElement } = descriptionElementRef;
  //     if (descriptionElement !== null) {
  //       descriptionElement.focus();
  //     }
  //   }
  // }, [open2]);
  // End

  // For Modal
  const [open] = React.useState(false);
  // const [, setScroll] = React.useState("paper");

  // const [wingname, setWingname] = React.useState("");
  // const [totalfloor, setTotalfloor] = React.useState("");
  // const [aprt, setAprt] = React.useState("");
  // const [aprtparking, setAprtParking] = React.useState("");
  // const [, setWingId] = React.useState();

  // const [ed_societyImage, setEdSocietyImage] = React.useState("");
  const [, setEdSocietyName] = React.useState("");
  const [, setEdEmailId] = React.useState("");
  const [, setEdContact] = React.useState("");
  const [, setEdBuildingCount] = React.useState("");
  const [, setEdAddress] = React.useState("");
  // const [ed_spotLayout, setEdSpotLayout] = React.useState("");
  // const [ed_GoogleMap, setEdGoogleMap] = React.useState("");
  //   const [ed_XAxis, setEdXAxis] = React.useState("");
  //   const [ed_YAxis, setEdYAxis] = React.useState("");
  // const [ed_latitude, setEdLatitude] = React.useState("");
  // const [ed_longitude, setEdLongitude] = React.useState("");

  // const [societyId, setSocietyId] = React.useState("");
  // const [societyObj, setSocietyObj] = React.useState({});
  const [, setDocumentsList] = React.useState([]);
  const [buildingList, setBuildingList] = React.useState([]);

  const [, setSelectedBuilding] = React.useState({});
  const [, setBuild_DocumentsList] = React.useState([]);
  const [wingList, setWingList] = React.useState([]);
  const [selectedWingIndex, setSelectedWingIndex] = React.useState(0);
  const [selectedBuildIndex, setSelectedBuildIndex] = React.useState(0);

  const [selectedBuildingId, setSelectedBuildingId] = React.useState();
  const [selectedBuildingName, setSelectedBuildingName] = React.useState();
  const [, setSelectedBuilTotWing] = React.useState();

  const [, setSelectedWingId] = React.useState();
  const [selectedWingName, setSelectedWingName] = React.useState();
  const [, setFloors_per_wing] = React.useState();
  const [, setApartment_per_floor] = React.useState();
  const [lstAptHashmap, setLstAptHashmap] = React.useState([]);
  const [allocatedApartments, setAllocatedApartments] = React.useState([]);
  // const [Update, setUpdate] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  // const [isAddWing, setIsWingAdd] = React.useState(true);
  const [, setIsBuildingAdd] = React.useState(true);

  // var formikInitials = {
  //   wingname: wingname,
  //   totalfloor: totalfloor,
  //   aprt: aprt,
  //   aprtparking: aprtparking,
  // };

  // const Validation_Schema = Yup.object().shape({
  //   wingname: Yup.string()
  //     .required("Required")
  //     .trim("White spaces not allow")
  //     .strict(true),
  //   totalfloor: Yup.string()
  //     .required("Required")
  //     .matches(/^\d+$/, "The field should have digits only"),
  //   aprt: Yup.string()
  //     .required("Required")
  //     .matches(/^\d+$/, "The field should have digits only"),
  //   aprtparking: Yup.string()
  //     .required("Required")
  //     .matches(/^\d+$/, "The field should have digits only"),
  // });

  // const handleClickOpen = (scrollType, wingData, index) => () => {
  //   console.log("www nnn", wingData);
  //   setOpen(true);
  //   setScroll(scrollType);
  //   setAptPerFloorErrorMsg("");
  //   setWingNameErrMsg("");
  //   setFloorPerWingErrorMsg("");
  //   setParkingPerAptmtErrorMsg("");

  //   setWingname(wingData.wing_name);
  //   setTotalfloor(wingData.floors_per_wing);
  //   setAprt(wingData.apartment_per_floor);
  //   setAprtParking(wingData.parking_per_apartment);
  //   setWingId(wingData.wing_id);

  //   localStorage.setItem("wing_id_new", wingData.wing_id);
  //   localStorage.setItem("wingIndex", index);
  // };

  // var formikInitials_EditSociety = {
  //   ed_societyName: ed_societyName,
  //   ed_emailId: ed_emailId,
  //   ed_contact: ed_contact,
  //   ed_buildingCount: ed_buildingCount,
  //   ed_address: ed_address,
  //   // ed_XAxis: ed_XAxis,
  //   // ed_YAxis: ed_YAxis,
  //   //  ed_latitude:ed_latitude,
  //   //  ed_longitude:ed_longitude,
  // };

  // const [contactErrMsg, setContactErrMsg] = React.useState("");
  const [, setBuildingCntErrMsg] = React.useState("");

  // const [wingNameErrorMsg, setWingNameErrMsg] = React.useState("");
  // const [floorPerWingErrorMsg, setFloorPerWingErrorMsg] = React.useState("");
  // const [aptPerFloorErrorMsg, setAptPerFloorErrorMsg] = React.useState("");
  // const [parkingPerAptmtErrorMsg, setParkingPerAptmtErrorMsg] =
  //   React.useState("");

  // const handleClose = () => {
  //   setOpen(false);
  // };

  // async function validateImageOrFile(fileData) {
  //   if (
  //     fileData.name.match(
  //       /.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|docx|DOCX|doc|DOC|pdf|PDF|xls|XLS|txt|TXT|xlsx|XLSX)$/i
  //     )
  //   )
  //     return true;
  //   else return false;
  // }

  // async function validateImage(fileData) {
  //   if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
  //     return true;
  //   else return false;
  // }

  // let document;
  // let tempArr = [];

  // const [gmaperrormsg, setGmapErrorMsg] = React.useState("");
  // const [spoterrormsg, setSpotErrMsg] = React.useState("");
  // const [socimgrrormsg, setSocImgErrMsg] = React.useState("");

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    if (open2) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    console.log(allocatedApartments);
    // GetUserData();
    if (localStorage.getItem("buildingCnt") > 0) {
      GetSocietyById(localStorage.getItem("socityid"));
    }
    else {
      GetBunglowHistory();
    }
  }, [open, open2]);

  const [societyName, setSocietyName] = React.useState("");
  const [societyImage, setSocietyImage] = React.useState("");
  const [contact, setContact] = React.useState("");
  const [emailId, setEmailId] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [buildingCnt, setBuildingCnt] = React.useState("");
  const [googleMapImage, setGoogleMapImage] = React.useState("");
  const [spotLayout, setSpotLayout] = React.useState("");
  const [docErrorMsg, setDocErrorMsg] = React.useState("");

  async function GetSocietyById(societyId) {
    var societyData = "";
    var bodyFormData = "";
    setShowLoader(true);
    await makeGetRequest("society/getbyid/" + societyId, bodyFormData)
      .then((response) => {
        console.log("Society Data ", response);
        if (response.status === 201) {
          societyData = response.data.data;
          console.log("IN Get Society");
          console.log(societyData);
          // setSocietyObj(societyData);
          setSocietyName(societyData.society_name);
          if (societyData.society_image)
            setSocietyImage(societyData.society_image);
          setContact(societyData.contact);
          setEmailId(societyData.email_id);
          setAddress(societyData.address);
          setBuildingCnt(societyData.building_count);
          if (societyData.google_map_image)
            setGoogleMapImage(societyData.google_map_image);
          if (societyData.spot_layout) setSpotLayout(societyData.spot_layout);

          if (societyData.document_list)
            setDocumentsList(societyData.document_list);

          setBuildingCntErrMsg("");
          setEdSocietyName(societyData.society_name);
          setEdAddress(societyData.address);
          setEdBuildingCount(societyData.building_count);
          setEdContact(societyData.contact);
          setEdEmailId(societyData.email_id);
          // setEdGoogleMap()

          if (societyData.building_count != 0) buildinglisting();
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
    // return societyObj;
  }

  async function buildinglisting() {
    let bodyFormData = "";

    await makeGetRequest(
      "building/getall/" + localStorage.getItem("socityid"),
      bodyFormData
    )
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data.rows;
          console.log("Building Data", data);
          localStorage.setItem("addedbuildingCnt", data.length);
          let tempBuilCnt = localStorage.getItem("buildingCnt");
          if (data.length < tempBuilCnt) setIsBuildingAdd(true);
          else setIsBuildingAdd(false);
          setBuildingList(data);
          setSelectedBuilding(data[0]);
          setSelectedBuildingName(data[0].building_name);
          setSelectedBuilTotWing(data[0].tot_wing);
          setBuild_DocumentsList(data[0].document_list);
          setSelectedBuildingId(data[0].building_id);
          setSelectedBuildIndex(data[0].building_id);
          if (data[0].is_wing) {
            setWingList(data[0].wing);
            setSelectedWingIndex(data[0].wing[0].wing_id);
            handleWingSelected(data[0].wing[0].wing_id, data[0].building_id);
          }
        } else {
          setBuildingList([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function handleBuildingSelected(buildingId) {
    setSelectedBuildIndex(buildingId);
    await makeGetRequest("building/getbyid/" + buildingId)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          console.log("Selected Building Data", data);
          setSelectedBuilding(data);
          setBuild_DocumentsList(data.document_list);
          setSelectedBuildingId(data.building_id);
          setSelectedBuildingName(data.building_name);
          setSelectedBuilTotWing(data.tot_wing);

          if (data.wing != null) {
            setWingList(data.wing);
            setSelectedWingIndex(data.wing[0].wing_id);
            handleWingSelected(data.wing[0].wing_id, data.building_id);
          } else {
            setWingList([]);
            setResidentList([]);
            setSelectedWingIndex();
            setSelectedWingId();
            setAllocatedApartments([]);
            setLstAptHashmap([]);
            setSelectedWingName("");
            setApartment_per_floor("");
            setFloors_per_wing("");

            // setSelectedWingName();
            // setApartment_per_floor();
            // setFloors_per_wing();
            // setLstAptHashmap();
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  let arr = [];
  async function handleWingSelected(wingId, buildingId) {
    setShowLoader(true);
    let wingName;
    if (buildingId == "" || buildingId == null || buildingId == 0)
      buildingId = selectedBuildingId;

    await makeGetRequest("wing/getbyid/" + wingId)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          console.log("wing Data", response.data);
          // setAllocatedApartments([]);
          setSelectedWingIndex(data.wing_id);
          setSelectedWingId(data.wing_id);
          setSelectedWingName(data.wing_name);
          setApartment_per_floor(data.apartment_per_floor);
          setFloors_per_wing(data.floors_per_wing);
          setLstAptHashmap(response.data.lstHashmap);

          wingName = data.wing_name;

          console.log(" APartment Res ");
          // alert(data.res.length);
          console.log(data.res);
          // for(var i=0;i<data.res.length;i++)
          // {
          //     console.log("Iterated ",i);
          //     allocatedApartments.push(data.res[i].apartment_no);
          // }

          // Loop through the car object
          if (data.res) {
            for (let i of data.res) {
              // Push the values of every object into arr
              arr.push(...Object.values(i));
            }

            console.log(arr);

            setAllocatedApartments(arr);
            setSelectedApartment("");
            console.log("Alloca " + allocatedApartments);
          } else {
            setAllocatedApartments([]);
          }
          setShowLoader(false);
        }
      })

      .catch((err) => {
        setShowLoader(false);
        console.log(err);
      });

    await makeGetRequest(
      "resident/apartmenthistory/" + buildingId + "/" + wingId
    )
      .then((response) => {
        console.log("History Data");
        console.log(response.data.data);
        if (response.data.data.length > 0) {
          setResidentList(response.data.data);
        }
        else {
          setResidentList([]);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setResidentList([]);
        setShowLoader(false);
        console.log(err);
      });
  }

  const [residentList, setResidentList] = React.useState([]);
  const [ownerName, setOwnerName] = React.useState("");
  const [ownerContactNo, setOwnerContactNo] = React.useState("");
  const [ownerProfile, setOwnerProfile] = React.useState("");
  const [ownerEmail, setOwnerEmail] = React.useState("");
  const [tempCnt, setTempCnt] = React.useState(0);
  const [allResidentList, setAllResidentList] = React.useState([]);

  const [selectedApartment, setSelectedApartment] = React.useState("");

  async function handleSelectedApartment(apartmentName) {
    setShowLoader(true);
    setSelectedApartment(apartmentName);

    let uniqAptName =
      selectedBuildingName + "/" + selectedWingName + "/" + apartmentName;
    let inputData = {
      apartmentName: uniqAptName,
    };
    await makePostRequest("resident/getbyaptname/", inputData)
      .then((response) => {
        if (response.data.data.length > 0) {
          console.log(response.data.data);

          setResidentList(response.data.data);
        } else {
          setResidentList([]);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        console.log(err);
      });
  }

  async function GetBunglowHistory() {
    await makeGetRequest(
      "resident/apartmenthistory/0/0")
      .then((response) => {
        console.log("History Data");
        console.log(response.data.data);
        if (response.data.data.length > 0) {
          setResidentList(response.data.data);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        console.log(err);
      });
  }

  const[showTitle,setShowTitle]=React.useState(true);
  async function HandleDiv()
  {
    // alert("In HandleDiv Function");ss
    setShowTitle(false);
  }
  // End

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">
              <EmojiTransportationIcon className="buildingIcoS" /> Apartment
              History
            </h1>
          </Grid>

          {localStorage.getItem("buildingCnt") > 0 ?
            <Grid item xs={12} md={12}>
              <div className="buildingYesMainNew">
                <div className="buldingInnerContent">

                  <Grid container spacing={3}>
                    {localStorage.getItem("buildingCnt") > 0 ? (
                      <>
                        <Grid item xs={12} md={12}>
                          <div className="allBuildingView">
                            <h1 className="viewHeading">All Buildings</h1>
                            <Grid container spacing={3}>
                              {buildingList.map((option, index) => (
                                <Grid item xs={12} md={3} key={index}>
                                  <div
                                    className="builNoDivOut"
                                    onClick={() =>
                                      handleBuildingSelected(option.building_id)
                                    }
                                  >
                                    <div
                                      className={
                                        selectedBuildIndex == option.building_id
                                          ? "builNoDivInr activeBuilding"
                                          : "builNoDivInr"
                                      }
                                    >
                                      <h2>{option.building_name}</h2>
                                      <p>Total wings : {option.tot_wing}</p>
                                      {/* <div className="editDeltetIconsDiv">
                                          <CreateIcon
                                            onClick={() =>
                                              navigate(
                                                "/EditBuilding/" +
                                                  option.building_id
                                              )
                                            }
                                          />
                                          <DeleteIcon
                                            onClick={() =>
                                              deleteBuilding(option.building_id)
                                            }
                                          />
                                        </div> */}
                                    </div>
                                  </div>
                                </Grid>
                              ))}
                            </Grid>
                          </div>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <div className="buildingDoqumentsDiv">
                            <h1 className="selectedBuildingName">
                              {selectedBuildingName}
                            </h1>
                          </div>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          {/* <Button className="forAddNewBuilBt addNewWingBtn">
                            <AddIcon /> Add New Wing
                          </Button> */}

                          {wingList.length > 0 ? (
                            <>
                              {wingList.map((option2, index) => (
                                <div className="addNewWingBtn" key={index}>
                                  <div className="tenentLeftContentMain">
                                    <ul>
                                      <li
                                        className={
                                          selectedWingIndex == option2.wing_id
                                            ? "addedApartCont activeTenent"
                                            : "addedApartCont"
                                        }
                                        onClick={() =>
                                          handleWingSelected(option2.wing_id)
                                        }
                                        key={index}
                                      >
                                        {/* <DeleteIcon className="delIc" /> */}
                                        <h4>
                                          <p>{option2.wing_name}</p>
                                        </h4>
                                        <span>
                                          {" "}
                                          Total apartments :{" "}
                                          {option2.floors_per_wing *
                                            option2.apartment_per_floor}
                                        </span>
                                        {/* <div className="editDeltetIconsDiv">
                                            <CreateIcon
                                              onClick={handleClickOpen(
                                                "body",
                                                option2,
                                                index
                                              )}
                                            />
                                            <DeleteIcon
                                              onClick={() =>
                                                deleteWing(option2.wing_id)
                                              }
                                            />
                                          </div> */}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              ))}
                            </>
                          ) : (
                            <></>
                          )}
                        </Grid>

                        {wingList.length == 0 ? (
                          <Grid item xs={12} md={12}>
                            <div className="errorField errorFieldFForLogin forInvalidImg topErrorMsg">
                              No Wings Found
                            </div>
                          </Grid>
                        ) : (
                          <></>
                        )}

                        {selectedWingIndex ? (
                          <Grid item xs={12} md={8}>
                            <div className="wingsTablsMainDiv priceTbMain wingPriceTbMain">
                              <table width="100%">
                                <thead>
                                  <tr className="thColr">
                                    <th colSpan={5} style={{ fontWeight: 600 }}>
                                      {selectedWingName}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colSpan={1}>Floors</td>
                                    <td colSpan={4}>Apartments</td>
                                  </tr>
                                  {lstAptHashmap.map((option, index) => (
                                    <tr>
                                      <td>
                                        <Tooltip
                                          title={"Floor " + option.key}
                                          arrow
                                        >
                                          <span>Floor {option.key}</span>
                                        </Tooltip>
                                      </td>
                                      {option.apartmentLst.map((option1) => (
                                        <>
                                          {allocatedApartments.includes(
                                            option1
                                          ) ? (
                                            <td
                                              className={
                                                option1 == selectedApartment
                                                  ? "onTdSelected"
                                                  : "selectedTd"
                                              }
                                              onClick={() =>
                                                handleSelectedApartment(option1)
                                              }
                                            >
                                              <Tooltip
                                                title={selectedBuildingName}
                                                arrow
                                              >
                                                <span> {option1}</span>
                                              </Tooltip>
                                            </td>
                                          ) : (
                                            <td
                                              className={
                                                option1 == selectedApartment
                                                  ? "onTdSelected"
                                                  : ""
                                              }
                                              onClick={() =>
                                                handleSelectedApartment(option1)
                                              }
                                            >
                                              <Tooltip
                                                title={selectedBuildingName}
                                                arrow
                                              >
                                                <span> {option1}</span>
                                              </Tooltip>
                                            </td>
                                          )}
                                        </>
                                      ))}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </Grid>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </Grid>

                  <div className="myNewHistoryMain">
                    {residentList.length > 0 ? (
                      <>
                        {residentList.map((option, index) => (
                          <>
                            <Grid container spacing={3}>
                              {/* {option.user_type != "tenent" ? ( */}
                              <Grid item xs={12} md={4}>
                                <h1 className="historyHead">Owner</h1>
                                <div className="historyOwnerMain">
                                  <div className="visitContDiv">
                                    <div className="visitCont1 resideNewContOut">
                                      <div className="visitContProf linkCOnt">
                                        {option.user_obj.profile_pic ? (
                                          <img
                                            src={option.user_obj.profile_pic}
                                          />
                                        ) : (
                                          <img src={AvatarImg} />
                                        )}
                                      </div>
                                      <div className="visitContLeft linkCOnt">
                                        {option.user_type == "tenent" ? (
                                          <h3
                                            className="visitContHed"
                                            onClick={() =>
                                              navigate(
                                                "/TenentManagInfoView/" +
                                                option.resident_id
                                              )
                                            }
                                          >
                                            {option.user_obj.first_name}{" "}
                                            {option.user_obj.last_name}
                                          </h3>
                                        ) : (
                                          <h3
                                            className="visitContHed"
                                            onClick={() =>
                                              navigate(
                                                "/ResidentManInfoView/" +
                                                option.resident_id
                                              )
                                            }
                                          >
                                            {option.user_obj.first_name}{" "}
                                            {option.user_obj.last_name}
                                          </h3>
                                        )}
                                        <p className="visitContMob">
                                          {option.user_obj.contact_no}
                                        </p>
                                        <p className="visitContTime forImailAlig">
                                          {option.user_obj.email_id}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Grid>
                              {/* ) : (
                              <Grid item xs={12} md={4}></Grid>
                            )} */}

                              <Grid item xs={12} md={8}>
                                {/* <div className="ownerInfoOuter"> */}

                                {option.apartment ? (
                                  <>
                                   {option.apartment.map((aptOption, index) => (
                                      <>
                                        <div className="historyOwnerMainRight occupancyBG">
                                          <h2 className="buildNFlatNo">
                                            <b>{aptOption.uniq_apt_name}</b>
                                            <span>
                                              ({aptOption.occupancy_type})
                                            </span>
                                          </h2>
                                          
                                          {aptOption.history ? (
                                            <>
                                              {aptOption.history.map(
                                                (tenentOption, index) => (
                                                  <>
                                                  {tenentOption.released_date ==
                                                          null ? (
                                                          <h1 className="historyHead">
                                                            Current occupant
                                                          </h1>
                                                        ) : (
                                                          <>
                                                          {index==1?
                                                          <h1 className="historyHead" >
                                                            Occupancy History
                                                            </h1>
                                                            :<></>}
                                                          </>
                                                        )}
                                                    {tenentOption.apartment_allocated_type ==
                                                      "Vacant" ||((tenentOption.apartment_allocated_type ==
                                                        "Tenant Occupied") &&(tenentOption.resident_id==option.resident_id) )? (
                                                      <>
                                                       <div
                                                          className="visitContDiv occupancyHistoryBG vacant"
                                                          style={{
                                                            position: "relative",
                                                            marginBottom: 20,
                                                          }}
                                                        >
                                                          <div className="textTagDiv">
                                                            Vacant
                                                          </div>

                                                          <div className="visitCont1 resideNewContOut minusSpace">
                                                            <div className="visitContLeft linkCOnt">
                                                              <h3 className="visitContHed">
                                                                <h3 className="visitContHed">
                                                                  {/* Shekhar Amodkar */}
                                                                  Vacant
                                                                </h3>
                                                                <span>
                                                                  (
                                                                  {
                                                                    tenentOption.apartment_allocated_type
                                                                  }
                                                                  )
                                                                </span>
                                                              </h3>
                                                            </div>

                                                            <div className="visitBottCont visitBottContForAilgn">
                                                              <p>From Date</p>
                                                              <div>
                                                                <b>
                                                                  {moment(
                                                                    tenentOption.occupied_date
                                                                  ).format(
                                                                    "DD-MM-YYYY"
                                                                  )}
                                                                </b>
                                                              </div>
                                                            </div>
                                                            <div className="visitBottCont visitBottContForAilgn">
                                                              <p>To Date</p>
                                                              <div>
                                                                {tenentOption.released_date ? (
                                                                  <b>
                                                                    {moment(
                                                                      tenentOption.released_date
                                                                    ).format(
                                                                      "DD-MM-YYYY"
                                                                    )}
                                                                  </b>
                                                                ) : (
                                                                  <b>-</b>
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      <>
                                                        {/* {tenentOption.released_date ==
                                                          null ? (
                                                          <h1 className="historyHead">
                                                            Current occupant
                                                          </h1>
                                                        ) : (
                                                          <h1 className="historyHead">
                                                            Occupancy History
                                                          </h1>
                                                        )} */}

                                                        <div
                                                          className={
                                                            tenentOption.released_date ==
                                                              null
                                                              ? "visitContDiv occupancyHistoryBG occupiedBg"
                                                              : "visitContDiv occupancyHistoryBG Released"
                                                          }
                                                          style={{
                                                            position: "relative",
                                                            marginBottom: 20,
                                                          }}
                                                        >
                                                          {tenentOption.released_date ? (
                                                            <div className="textTagDiv">
                                                              Released
                                                            </div>
                                                          ) : (
                                                            <div className="textTagDiv">
                                                              Occupied
                                                            </div>
                                                          )}

                                                          <div className="visitCont1 resideNewContOut">
                                                            <div className="visitContProf linkCOnt">
                                                              {tenentOption
                                                                .user_obj
                                                                .profile_pic ? (
                                                                <img
                                                                  src={
                                                                    tenentOption
                                                                      .user_obj
                                                                      .profile_pic
                                                                  }
                                                                />
                                                              ) : (
                                                                <img
                                                                  src={AvatarImg}
                                                                />
                                                              )}
                                                            </div>
                                                            <div className="visitContLeft linkCOnt">
                                                              <h3 className="visitContHed">
                                                                {tenentOption.user_type ==
                                                                  "tenent" ? (
                                                                  <h3
                                                                    className="visitContHed"
                                                                    onClick={() =>
                                                                      navigate(
                                                                        "/TenentManagInfoView/" +
                                                                        tenentOption.resident_id
                                                                      )
                                                                    }
                                                                  >
                                                                    {
                                                                      tenentOption
                                                                        .user_obj
                                                                        .first_name
                                                                    }{" "}
                                                                    {
                                                                      tenentOption
                                                                        .user_obj
                                                                        .last_name
                                                                    }
                                                                  </h3>
                                                                ) : (
                                                                  <h3
                                                                    className="visitContHed"
                                                                    onClick={() =>
                                                                      navigate(
                                                                        "/ResidentManInfoView/" +
                                                                        tenentOption.resident_id
                                                                      )
                                                                    }
                                                                  >
                                                                    {
                                                                      tenentOption
                                                                        .user_obj
                                                                        .first_name
                                                                    }{" "}
                                                                    {
                                                                      tenentOption
                                                                        .user_obj
                                                                        .last_name
                                                                    }
                                                                  </h3>
                                                                )}
                                                                {tenentOption.user_type ==
                                                                  "tenent" ? (
                                                                  <span>
                                                                    (Tenant)
                                                                  </span>
                                                                ) : (
                                                                  <span>
                                                                    (Owner)
                                                                  </span>
                                                                )}
                                                              </h3>
                                                              <p className="visitContMob">
                                                                {" "}
                                                                {
                                                                  tenentOption
                                                                    .user_obj
                                                                    .contact_no
                                                                }
                                                              </p>
                                                              <p className="visitContTime forImailAlig">
                                                                {
                                                                  tenentOption
                                                                    .user_obj
                                                                    .email_id
                                                                }
                                                              </p>
                                                            </div>
                                                            <div className="visitBottCont visitBottContForAilgn">
                                                              {tenentOption.released_date ? (
                                                                <>
                                                                  <p>
                                                                    Occupancy Date
                                                                  </p>
                                                                  <div>
                                                                    <b>
                                                                      {moment(
                                                                        tenentOption.occupied_date
                                                                      ).format(
                                                                        "DD-MM-YYYY"
                                                                      )}{" "}
                                                                      to{" "}
                                                                      {moment(
                                                                        tenentOption.released_date
                                                                      ).format(
                                                                        "DD-MM-YYYY"
                                                                      )}{" "}
                                                                    </b>
                                                                  </div>
                                                                </>
                                                              ) : (
                                                                <>
                                                                  <p>
                                                                    Occupied on
                                                                  </p>
                                                                  <div>
                                                                    <b>
                                                                      {moment(
                                                                        tenentOption.created_at
                                                                      ).format(
                                                                        "DD-MM-YYYY"
                                                                      )}{" "}
                                                                    </b>
                                                                  </div>
                                                                </>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </>
                                                    )}
                                                  </>
                                                )
                                              )}
                                            </>
                                          ) : (
                                            <div>
                                              <span className="noRecordTx">
                                                <ReportProblemIcon /> No Tenent
                                                Occupied
                                              </span>
                                            </div>
                                          )}
                                        </div>

                                        {/* </>:<></>} */}
                                      </>
                                    ))}
                                  </>
                                ) : (
                                  <></>
                                )}
                                {/* </div> */}
                              </Grid>

                              <Grid item xs={12} md={12}>
                                <div className="devidreNewSt"></div>
                              </Grid>
                            </Grid>
                          </>
                        ))}
                      </>
                    ) : (
                      <Grid item xs={12} md={12}>
                        <div className="visitContLeft linkCOnt apartAllocated">
                          <h3 className="visitContHed">
                            <ReportProblemIcon /> Apartment not allocated
                          </h3>
                        </div>
                      </Grid>
                    )}
                  </div>

                </div>
              </div>
            </Grid>
            :
            <Grid item xs={12} md={12}>
              <div className="buildingYesMainNew">
                <div className="buldingInnerContent">

                  <div className="myNewHistoryMain">
                    {residentList.length > 0 ? (
                      <>
                        {residentList.map((option, index) => (
                          <>
                            <Grid container spacing={3}>
                              {/* {option.user_type != "tenent" ? ( */}
                              <Grid item xs={12} md={4}>
                                <h1 className="historyHead">Owner</h1>
                                <div className="historyOwnerMain">
                                  <div className="visitContDiv">
                                    <div className="visitCont1 resideNewContOut">
                                      <div className="visitContProf linkCOnt">
                                        {option.user_obj.profile_pic ? (
                                          <img
                                            src={option.user_obj.profile_pic}
                                          />
                                        ) : (
                                          <img src={AvatarImg} />
                                        )}
                                      </div>
                                      <div className="visitContLeft linkCOnt">
                                        {option.user_type == "tenent" ? (
                                          <h3
                                            className="visitContHed"
                                            onClick={() =>
                                              navigate(
                                                "/TenentManagInfoView/" +
                                                option.resident_id
                                              )
                                            }
                                          >
                                            {option.user_obj.first_name}{" "}
                                            {option.user_obj.last_name}
                                          </h3>
                                        ) : (
                                          <h3
                                            className="visitContHed"
                                            onClick={() =>
                                              navigate(
                                                "/ResidentManInfoView/" +
                                                option.resident_id
                                              )
                                            }
                                          >
                                            {option.user_obj.first_name}{" "}
                                            {option.user_obj.last_name}
                                          </h3>
                                        )}
                                        <p className="visitContMob">
                                          {option.user_obj.contact_no}
                                        </p>
                                        <p className="visitContTime forImailAlig">
                                          {option.user_obj.email_id}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Grid>
                              {/* ) : (
                            <Grid item xs={12} md={4}></Grid>
                          )} */}

                              <Grid item xs={12} md={8}>
                                {/* <div className="ownerInfoOuter"> */}

                                {option.apartment ? (
                                  <>
                                    {option.apartment.map((aptOption, index) => (
                                      <>
                                        <div className="historyOwnerMainRight occupancyBG">
                                          <h2 className="buildNFlatNo">
                                            <b>{aptOption.uniq_apt_name}</b>
                                            <span>
                                              ({aptOption.occupancy_type})
                                            </span>
                                          </h2>
                                          {/* {aptOption.released_date==null?
                                      <h1 className="historyHead">
                                      Current occupant
                                    </h1>
                                        :
                                      <h1 className="historyHead">
                                        Occupancy History
                                      </h1>
                                      } */}
                                          {aptOption.history ? (
                                            <>
                                              {aptOption.history.map(
                                                (tenentOption, index) => (
                                                  <>
                                                    {tenentOption.apartment_allocated_type ==
                                                      "Vacant" ? (
                                                      <>
                                                        {/* <h1 className="historyHead">
                                        Vacant
                                      </h1> */}
                                                        <div
                                                          className="visitContDiv occupancyHistoryBG vacant"
                                                          style={{
                                                            position: "relative",
                                                            marginBottom: 20,
                                                          }}
                                                        >
                                                          <div className="textTagDiv">
                                                            Vacant
                                                          </div>

                                                          <div className="visitCont1 resideNewContOut minusSpace">
                                                            <div className="visitContLeft linkCOnt">
                                                              <h3 className="visitContHed">
                                                                <h3 className="visitContHed">
                                                                  {/* Shekhar Amodkar */}
                                                                  Vacant Apartment
                                                                </h3>
                                                                <span>
                                                                  (
                                                                  {
                                                                    tenentOption.apartment_allocated_type
                                                                  }
                                                                  )
                                                                </span>
                                                              </h3>
                                                            </div>

                                                            <div className="visitBottCont visitBottContForAilgn">
                                                              <p>From Date</p>
                                                              <div>
                                                                <b>
                                                                  {moment(
                                                                    tenentOption.occupied_date
                                                                  ).format(
                                                                    "DD-MM-YYYY"
                                                                  )}
                                                                </b>
                                                              </div>
                                                            </div>
                                                            <div className="visitBottCont visitBottContForAilgn">
                                                              <p>To Date</p>
                                                              <div>
                                                                {tenentOption.released_date ? (
                                                                  <b>
                                                                    {moment(
                                                                      tenentOption.released_date
                                                                    ).format(
                                                                      "DD-MM-YYYY"
                                                                    )}
                                                                  </b>
                                                                ) : (
                                                                  <b>-</b>
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      <>
                                                        {tenentOption.released_date ==
                                                          null ? (
                                                          <h1 className="historyHead">
                                                            Current occupant
                                                          </h1>
                                                        ) : (
                                                          <h1 className="historyHead">
                                                            Occupancy History
                                                          </h1>
                                                        )}

                                                        <div
                                                          className={
                                                            tenentOption.released_date ==
                                                              null
                                                              ? "visitContDiv occupancyHistoryBG occupiedBg"
                                                              : "visitContDiv occupancyHistoryBG Released"
                                                          }
                                                          style={{
                                                            position: "relative",
                                                            marginBottom: 20,
                                                          }}
                                                        >
                                                          {tenentOption.released_date ? (
                                                            <div className="textTagDiv">
                                                              Released
                                                            </div>
                                                          ) : (
                                                            <div className="textTagDiv">
                                                              Occupied
                                                            </div>
                                                          )}

                                                          <div className="visitCont1 resideNewContOut">
                                                            <div className="visitContProf linkCOnt">
                                                              {tenentOption
                                                                .user_obj
                                                                .profile_pic ? (
                                                                <img
                                                                  src={
                                                                    tenentOption
                                                                      .user_obj
                                                                      .profile_pic
                                                                  }
                                                                />
                                                              ) : (
                                                                <img
                                                                  src={AvatarImg}
                                                                />
                                                              )}
                                                            </div>
                                                            <div className="visitContLeft linkCOnt">
                                                              <h3 className="visitContHed">
                                                                {option.user_type ==
                                                                  "tenent" ? (
                                                                  <h3
                                                                    className="visitContHed"
                                                                    onClick={() =>
                                                                      navigate(
                                                                        "/TenentManagInfoView/" +
                                                                        tenentOption.resident_id
                                                                      )
                                                                    }
                                                                  >
                                                                    {
                                                                      tenentOption
                                                                        .user_obj
                                                                        .first_name
                                                                    }{" "}
                                                                    {
                                                                      tenentOption
                                                                        .user_obj
                                                                        .last_name
                                                                    }
                                                                  </h3>
                                                                ) : (
                                                                  <h3
                                                                    className="visitContHed"
                                                                    onClick={() =>
                                                                      navigate(
                                                                        "/ResidentManInfoView/" +
                                                                        tenentOption.resident_id
                                                                      )
                                                                    }
                                                                  >
                                                                    {
                                                                      tenentOption
                                                                        .user_obj
                                                                        .first_name
                                                                    }{" "}
                                                                    {
                                                                      tenentOption
                                                                        .user_obj
                                                                        .last_name
                                                                    }
                                                                  </h3>
                                                                )}
                                                                {tenentOption.user_type ==
                                                                  "tenent" ? (
                                                                  <span>
                                                                    (Tenant)
                                                                  </span>
                                                                ) : (
                                                                  <span>
                                                                    (Owner)
                                                                  </span>
                                                                )}
                                                              </h3>
                                                              <p className="visitContMob">
                                                                {" "}
                                                                {
                                                                  tenentOption
                                                                    .user_obj
                                                                    .contact_no
                                                                }
                                                              </p>
                                                              <p className="visitContTime forImailAlig">
                                                                {
                                                                  tenentOption
                                                                    .user_obj
                                                                    .email_id
                                                                }
                                                              </p>
                                                            </div>
                                                            <div className="visitBottCont visitBottContForAilgn">
                                                              {tenentOption.released_date ? (
                                                                <>
                                                                  <p>
                                                                    Occupancy Date
                                                                  </p>
                                                                  <div>
                                                                    <b>
                                                                      {moment(
                                                                        tenentOption.occupied_date
                                                                      ).format(
                                                                        "DD-MM-YYYY"
                                                                      )}{" "}
                                                                      to{" "}
                                                                      {moment(
                                                                        tenentOption.released_date
                                                                      ).format(
                                                                        "DD-MM-YYYY"
                                                                      )}{" "}
                                                                    </b>
                                                                  </div>
                                                                </>
                                                              ) : (
                                                                <>
                                                                  <p>
                                                                    Occupied on
                                                                  </p>
                                                                  <div>
                                                                    <b>
                                                                      {moment(
                                                                        tenentOption.created_at
                                                                      ).format(
                                                                        "DD-MM-YYYY"
                                                                      )}{" "}
                                                                    </b>
                                                                  </div>
                                                                </>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </>
                                                    )}
                                                  </>
                                                )
                                              )}
                                            </>
                                          ) : (
                                            <div>
                                              <span className="noRecordTx">
                                                <ReportProblemIcon /> No Tenent
                                                Occupied
                                              </span>
                                            </div>
                                          )}
                                        </div>

                                        {/* </>:<></>} */}
                                      </>
                                    ))}
                                  </>
                                ) : (
                                  <></>
                                )}
                                {/* </div> */}
                              </Grid>

                              <Grid item xs={12} md={12}>
                                <div className="devidreNewSt"></div>
                              </Grid>
                            </Grid>
                          </>
                        ))}
                      </>
                    ) : (
                      <Grid item xs={12} md={12}>
                        <div className="visitContLeft linkCOnt apartAllocated">
                          <h3 className="visitContHed">
                            <ReportProblemIcon /> Bunglow not allocated
                          </h3>
                        </div>
                      </Grid>
                    )}
                  </div>

                </div>
              </div>
            </Grid>}
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default ApartmentHistory;
